export default "__VITE_ASSET__6$6qyvMX__"